interface IApi {
    Food: {
        getInfo: string
        getMenu: string
    }
}

export const Api: Readonly<IApi> = {
    Food: {
        getInfo: 'json/bohoInfo.json',
        getMenu: 'json/bohoMenu.json'
    }
}